import styled from 'styled-components';

import FormStylesOptions from '../../../constants/FormStylesOptions';
import { hasVisibleDecorators } from './FieldDecorators';

/**
 * Whether the header row above a field shows anything: the same tests FieldTitle and
 * FieldDecorators use to decide whether they draw. Nothing else is ever rendered inside the
 * header, so an empty header is a hidden or blank title with no visible decorators.
 */
export const isFieldHeaderEmpty = ({ title, titleDisplay, decorators, fieldMode }) => (
  (!title || titleDisplay === FormStylesOptions.displayNone)
  && !hasVisibleDecorators(decorators, fieldMode)
);

/**
 * The title + decorators row every field draws above its value. Shared so the spacing rule can
 * not drift between field types again.
 *
 * The 4px gap under the title. rc12 kept it on the title label, so a hidden title took no room.
 * rc13 moved it here for decorators and it started applying to an empty header too: every field
 * with its title hidden lost 4px at the top and was drawn 4px low, which on short PDF boxes put
 * the value across the printed cell border.
 *
 * Only the gap is conditional; the element always renders. TableFieldv2 and CollectionField
 * measure it as the first PDF split unit, and ImageField reads its height in pdf mode.
 */
export const StyledFieldHeader = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 6px;
  padding-right: 20px;

  ${(props) => (props.$empty ? '' : 'padding-bottom: 4px;')}
`;
